import Axios from "@/plugins/Axios";
import store from "@/store";
import SubEtapa from "@/Models/SubEtapa";

export class SubEtapasService {
  async syncAll(circuito_nota_id) {
    const response = await Axios().get(`sub-etapas?circuito_nota_id=${circuito_nota_id}`);
    const subEtapas = response.data.map((subEtapa) => new SubEtapa(subEtapa));
    return subEtapas;
  }

  async criarSubEtapa(subEtapa) {
    const response = await Axios().post("sub-etapas", subEtapa);
    const novoSubEtapa = response.data;
    return novoSubEtapa;
  }

  async atualizarSubEtapa(circuito) {
    const response = await Axios().put(`sub-etapas/${circuito.id}`, circuito);
    const etapa = response.data;
    return etapa;
  }

  async deletarSubEtapa(dado) {
    const response = await Axios().delete(`sub-etapas/${dado.id}`);
    const subEtapaDeletada = response.data;
    return subEtapaDeletada;
  }
}
export default new SubEtapasService();
